var map = {
	"./angular.png": 8611,
	"./bootstrap.png": 51,
	"./c.png": 1906,
	"./canva.png": 1752,
	"./css.png": 2160,
	"./django.png": 9364,
	"./docker.png": 1641,
	"./excel.png": 7172,
	"./express.png": 1953,
	"./figma.png": 7893,
	"./go.png": 9139,
	"./html.png": 9214,
	"./java.png": 6229,
	"./javascript.png": 4056,
	"./jira.png": 2209,
	"./laravel.png": 8482,
	"./nestjs.png": 3842,
	"./nextjs.png": 6431,
	"./nodejs.png": 1660,
	"./notion.png": 2698,
	"./photoshop.png": 6505,
	"./php.png": 6113,
	"./powerpoint.png": 5026,
	"./python.png": 415,
	"./rails.png": 1190,
	"./react.png": 4900,
	"./ruby.png": 8909,
	"./spring.png": 8950,
	"./sql.png": 8233,
	"./symfony.png": 2530,
	"./tailwind.png": 6429,
	"./trello.png": 123,
	"./typescript.png": 7296,
	"./word.png": 8569,
	"./wordpress.png": 8060,
	"./youtrack.png": 8911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9945;